import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconCalendar = createIcon({
  displayName: 'IconCalendar',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M8 2H6V4H3V6H21V4H18V2H16V4H8V2ZM3 21H21V12H19V19H5V10H21V8H3V21Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
